export default {
  Emoji: {
    Reacted: 'reacted',
    You: 'You',
    PlusNOthers: 'plus %(n)i other',
  },
  ToolBar: {
    Emoji: 'Emoji',
    Copy: 'Copy',
    Edit: 'Edit',
    Delete: 'Delete',
  },
};
